import { render } from "./DeleteSubProcessModal.vue?vue&type=template&id=e9b7a630&scoped=true&ts=true"
import script from "./DeleteSubProcessModal.vue?vue&type=script&lang=ts"
export * from "./DeleteSubProcessModal.vue?vue&type=script&lang=ts"

import "./DeleteSubProcessModal.vue?vue&type=style&index=0&id=e9b7a630&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b7a630"]])

export default __exports__